import useNotificationAction from '../hooks/useNotificationAction'
import { ReactComponent as Service } from 'assets/service.svg'
import { itIsToday, toShortDate, toTime } from 'utils/date'
import useTranslation from 'hooks/useTranslation'
import React, { useRef, useState } from 'react'

interface NotificationProps extends chat.Notification { }

const Notification: React.FC<NotificationProps> = ({ id, type, title, description, read_date, datetime, icon, action }) => {
  const [trash, setTrash] = useState(0)
  const { lang } = useTranslation()

  const date = new Date(datetime)
  const wrapperRef = useRef<HTMLDivElement>(null)

  const { remove, performAction } = useNotificationAction()
  const onTouchStart: React.TouchEventHandler<HTMLDivElement> = e => {
    const wrapper = wrapperRef.current
    if (!wrapper) return

    let updateState = true
    const initialX = e.touches[0].clientX

    const touchMove = (e: TouchEvent) => {
      const currentX = e.touches[0].clientX
      const difference = initialX - currentX
      updateState = difference < 80
      if (updateState) setTrash(difference > 0 ? Number((difference / 50).toFixed(1)) : 0)
    }

    const touchEnd = () => {
      setTrash(0)
      if (!updateState) remove(id)
      wrapper.removeEventListener('touchend', touchEnd, false)
      wrapper.removeEventListener('touchmove', touchMove, false)
    }

    wrapper.addEventListener('touchend', touchEnd, false)
    wrapper.addEventListener('touchmove', touchMove, false)
  }

  return (
    <div
      ref={wrapperRef}
      className='list__contact__wrapper'
      onTouchStart={onTouchStart}>
      <div
        className={`list__contact group --${type}${read_date ? ' --darkened' : ''}`}
        onClick={() => {
          performAction(id, action, read_date)
        }}>
        <div className='contact__avatar center'>
          {icon === 'service'
            ? <Service className='service' />
            : <i className='icon icon--logo s24' />}
        </div>
        <div className='contact__desc'>
          <div className='--secFont'>{title}</div>
          <div className='chat__text'>{description}</div>
        </div>
        <div className='contact__time chat__text'>
          {itIsToday(datetime)
            ? toTime(date, lang)
            : toShortDate(date, lang)}
        </div>
      </div>
      {trash !== 0 && <div
        className='list__contact__delete center'
        style={{
          transform: `scale(${trash})`,
          padding: `${trash / 2}em`
        }}>
        <i className='icon icon--trash' />
      </div>}
    </div>
  )
}

export default Notification